import React from "react";
import "./style.scss";
import { Layout, PageHeader, Space, Button, Table, Avatar, Select } from "antd";
import { useHistory } from "react-router";
import R2Footer from "../../../components/Footer";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import profileIcon from "../../../assets/images/profile.svg";
import AssignEmployeeModal from "./AssignSection";
import { useState } from "react";
import { useEffect } from "react";
import PosService from "../../../services/PosService";
import { useSelector } from "react-redux";
import EmployeeService from "../../../services/EmployeeService";
import Spinner from "../../../components/Layout/Spinner";


const { Content } = Layout;
const { Option } = Select;

const EmployeeManagement = () => {
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [rowData, setRowData] = useState({});
  const [section, setSectionData] = useState([]);
  const [server, setServer] = useState([]);
  const adminRestaurant = useSelector((state) => state.admin);
  const [employees, setEmployees] = useState([]);

  // useEffect(() => {section
  //   (async () => {
  //     const data = await PosService.getSectionWithFloor(adminRestaurant);
  //     const employee = await PosService.getEmployeeForPos(adminRestaurant);
  //     setServer(employee?.employees);
  //     const arr = [];
  //     data.map((val) => {
  //       const obj = {
  //         title: "Floor " + val.floor,
  //         value: val.floor,
  //         children: [],
  //       };
  //       val.section.map((section) => {
  //         obj.children.push({ title: "Section " + section, value: section });
  //       });
  //       arr.push(obj);
  //     });
  //     setSectionData(arr);
  //   })();
  // }, []);

  const closeModal = () => {
    setModalOpen(false);
  };
  useEffect(() => {
    getEmployees();
  }, [adminRestaurant]);

  const getEmployees = async () => {
    // const data = await EmployeeService.getEmployees();
    // const posEmp = await PosService.getEmployeeForPos(adminRestaurant)
    setLoading(true)
    const data = await PosService.getEmployeeForPosServer(adminRestaurant);

    const sectiondata = await PosService.getSections(adminRestaurant);
    setSectionData(sectiondata);
    setEmployees(data);
    setLoading(false)
  };
  const handleChange = async (value, id) => {
    console.log(`selected ${value}`);
  };
  const columns = [
    {
      title: "",
      dataIndex: "",
      key: "",
      width: 100,
      render: (_, record) => {
        return (
          <div>
            {record.photo_url ?
            <Avatar size="large" src={record.photo_url} style={{ marginRight: "10px" }}>
            
          </Avatar>
            :
            <Avatar size="large" style={{ marginRight: "10px" }}>
              {record.name}
            </Avatar>
      }
          </div>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      render: (_, record) => {
        return (
          <div style={{ display: "flex" }}>
            <div className="name_text">{record.name}</div>
          </div>
        );
      },
    },
    {
      title: "Section Assigned",
      dataIndex: "section",
      render: (_, record) => {
        return (
          <div>
            {record.sections?.length>0 ?
            <div>
                {record.sections?.map(item=>
                  <div>{"Floor-"+item.floor +" : "+"Section"+ item.name}</div>
                )}
            </div>
            :
            <Button
              className={
                record?.section &&
                record?.section?.length > 0 &&
                record?.section?.filter((item) => item != null)?.length > 0
                  ? "section_text-green"
                  : "section_text-red"
              }
              
              style={{ width: 180 }}
              onClick={(value) =>{setRowData(record);
                setModalOpen(true);}}
            >
              {
                record.section &&
                record?.section?.filter((item) => item != null)?.length > 0
                  ? record.section[0]
                  : "Not Assigned"
              }
              </Button>
      }
              {/* {record?.section &&
                record?.section
                  ?.filter((item) => item != null)
                  .map((item) => (
                    <Option key={item} value={item}>
                      Section {item}
                    </Option>
                  ))}
            </Select> */}
          </div>
        );
      },
    },
    {
      title: "Code",
      dataIndex: "employee_code",
      key: "employee_code",
      render: (_, record) => {
        return (
          <div className="code_text">{record?.restaurant_role?.employee_code}</div>
        );
      },
    },
    {
      title: "",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
            }}
          >
            <>
              <EditOutlined
                onClick={(e) => {
                  e.stopPropagation();
                  setRowData(record);
                  setModalOpen(true);
                }}
              />{" "}
            </>
          </div>
        );
      },
    },
  ];
  return (
    <Layout className="u-page-layout">
      <Content className="w-full page-padding">
        <Space direction="vertical" style={{ width: "100%" }}>
          <PageHeader
          className="page-header"
            title="Server Management"
            extra={[
              <Button
                type="primary"
                onClick={() => {
                  history.push(`/business/employees/add?employee_type=SERVER`);
                }}
              >
                Add Server
              </Button>,
            ]}
          />
          <Table
            columns={columns}
            dataSource={employees}
            className="discount-table overflow-auto"
          />
        </Space>
      </Content>
      <R2Footer />
      <AssignEmployeeModal
        modalOpen={modalOpen}
        closeModal={closeModal}
        data={rowData}
        section={section}
      />
      {isLoading && <Spinner/>}
    </Layout>
  );
};

export default EmployeeManagement;
